import 'react-native-url-polyfill/auto';
import React from 'react';
import { ActivityIndicator, StyleSheet, View } from 'react-native';
import { StatusBar } from 'expo-status-bar';
import { useFonts } from 'expo-font';
import { GestureHandlerRootView } from 'react-native-gesture-handler';
import { SafeAreaProvider } from 'react-native-safe-area-context';
import { AuthProvider, useAuth } from './src/auth/AuthProvider';
import { LoginScreen } from './src/screens/LoginScreen';
import { OlmpsCore } from './src/olmps/OlmpsCore';
import { TalkHost } from './src/v10/TalkingOverlay';
import { colors, fonts } from './src/domain/tokens';
import { CrossAlertHost } from './src/lib/crossAlert';

function Root() {
  const { session, loading } = useAuth();
  if (loading) {
    return (
      <View style={styles.loading}>
        <ActivityIndicator size="large" color={colors.blueText} />
      </View>
    );
  }
  if (!session) return <LoginScreen />;
  // The talk overlay sits above the shell, so a live call survives the shell switching views
  // (a voice agent opening a tool, rotating, ...). Council mode lives inside the Pantheon.
  return (
    <View style={styles.flex}>
      <OlmpsCore />
      <TalkHost />
    </View>
  );
}

export default function App() {
  const [fontsLoaded] = useFonts({
    [fonts.title]: require('./assets/fonts/ZeraphineObsidianSerif-Regular.ttf'),
  });

  if (!fontsLoaded) {
    return (
      <View style={styles.loading}>
        <ActivityIndicator size="large" color={colors.blueText} />
      </View>
    );
  }

  return (
    <GestureHandlerRootView style={styles.flex}>
      <SafeAreaProvider>
        <AuthProvider>
          <StatusBar style="dark" />
          <Root />
          <CrossAlertHost />
        </AuthProvider>
      </SafeAreaProvider>
    </GestureHandlerRootView>
  );
}

const styles = StyleSheet.create({
  flex: { flex: 1 },
  loading: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: colors.bgTop,
  },
});
